import { render, staticRenderFns } from "./typingFirstB.vue?vue&type=template&id=7ed5cdfc&scoped=true&"
import script from "./typingFirstB.vue?vue&type=script&lang=js&"
export * from "./typingFirstB.vue?vue&type=script&lang=js&"
import style0 from "./typingFirstB.vue?vue&type=style&index=0&id=7ed5cdfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed5cdfc",
  null
  
)

export default component.exports